
/* ============================================================
   SAUNII V2 — Theme JavaScript
   Clean replacement version
   ============================================================ */

(function () {
  'use strict';

  /* Prevent this entire file from running more than once */
  if (window.__SAUNII_V2_INITIALIZED__) return;
  window.__SAUNII_V2_INITIALIZED__ = true;

  /* ============================================================
     PRODUCT QUANTITY COUNTER
     Runs in capture mode so other scripts cannot also change it
     ============================================================ */

  function getQuantityInput(button) {
    var container =
      button.closest('.product-page__qty') ||
      button.closest('[data-quantity-selector]') ||
      button.closest('.quantity') ||
      button.parentElement;

    var input = container
      ? container.querySelector(
          '.product-page__qty-input, input[name="quantity"]'
        )
      : null;

    if (!input) {
      var form = button.closest('form');

      if (form) {
        input = form.querySelector(
          '.product-page__qty-input, input[name="quantity"]'
        );
      }
    }

    return input;
  }

  function getNumber(value, fallback) {
    var number = parseInt(value, 10);
    return Number.isNaN(number) ? fallback : number;
  }

  window.addEventListener(
    'click',
    function (event) {
      if (!(event.target instanceof Element)) return;

      var button = event.target.closest(
        '[data-qty-plus], [data-qty-minus]'
      );

      if (!button) return;

      /*
       Stop every other quantity script from processing
       this same click.
      */
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (button.disabled || button.getAttribute('aria-disabled') === 'true') {
        return;
      }

      var input = getQuantityInput(button);

      if (!input) {
        console.warn('[Saunii] Quantity input not found.');
        return;
      }

      var minimum = getNumber(input.getAttribute('min'), 1);
      var maximum = getNumber(input.getAttribute('max'), Infinity);
      var current = getNumber(input.value, minimum);
      var next = current;

      if (button.hasAttribute('data-qty-plus')) {
        next = current + 1;
      }

      if (button.hasAttribute('data-qty-minus')) {
        next = current - 1;
      }

      next = Math.max(minimum, next);
      next = Math.min(maximum, next);

      input.value = String(next);

      /*
       Let the product form know the quantity changed,
       without creating another click.
      */
      input.dispatchEvent(
        new Event('input', {
          bubbles: true
        })
      );

      input.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    },
    true
  );

  /* ============================================================
     DOCUMENT READY
     ============================================================ */

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, {
        once: true
      });
    } else {
      callback();
    }
  }

  ready(function () {
    /* ==========================================================
       HELPERS
       ========================================================== */

    function lockScroll() {
      document.body.style.overflow = 'hidden';
    }

    function unlockScrollIfNothingOpen() {
      var menuOpen =
        document.body.classList.contains('mobile-menu-open');

      var cartOpen =
        document.body.classList.contains('cart-drawer-open');

      var productDrawerOpen =
        document.body.classList.contains('product-drawer-open');

      var popupOpen =
        document.body.classList.contains('popup-open');

      if (
        !menuOpen &&
        !cartOpen &&
        !productDrawerOpen &&
        !popupOpen
      ) {
        document.body.style.overflow = '';
      }
    }

    /* ==========================================================
       MOBILE MENU
       ========================================================== */

    var mobileMenu = document.getElementById('mobile-menu');

    function openMobileMenu() {
      if (!mobileMenu) return;

      mobileMenu.classList.add('active', 'open', 'is-open');
      mobileMenu.setAttribute('aria-hidden', 'false');

      document.body.classList.add('mobile-menu-open');

      lockScroll();
    }

    function closeMobileMenu() {
      if (!mobileMenu) return;

      mobileMenu.classList.remove('active', 'open', 'is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');

      document.body.classList.remove('mobile-menu-open');

      unlockScrollIfNothingOpen();
    }

    document
      .querySelectorAll('[data-mobile-toggle]')
      .forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          openMobileMenu();
        });
      });

    document
      .querySelectorAll('[data-mobile-close]')
      .forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          closeMobileMenu();
        });
      });

    /* ==========================================================
       PRODUCT INFO DRAWERS
       Details, Fabric & Care, Size
       ========================================================== */

    function closeProductDrawer(drawer) {
      if (!drawer) return;

      drawer.classList.remove('open', 'active', 'is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }

    function closeAllProductDrawers() {
      document
        .querySelectorAll('[data-drawer]')
        .forEach(function (drawer) {
          closeProductDrawer(drawer);
        });

      document.body.classList.remove(
        'product-drawer-open',
        'details-drawer-open'
      );

      unlockScrollIfNothingOpen();
    }

    function checkProductDrawerState() {
      var openDrawer = document.querySelector(
        '[data-drawer].open, ' +
          '[data-drawer].active, ' +
          '[data-drawer].is-open'
      );

      if (!openDrawer) {
        document.body.classList.remove(
          'product-drawer-open',
          'details-drawer-open'
        );
      }

      unlockScrollIfNothingOpen();
    }

    document
      .querySelectorAll('[data-drawer-trigger]')
      .forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();

          var drawerName =
            button.getAttribute('data-drawer-trigger');

          var drawer = document.getElementById(
            'drawer-' + drawerName
          );

          if (!drawer) {
            console.warn(
              '[Saunii] Drawer not found:',
              'drawer-' + drawerName
            );

            return;
          }

          document
            .querySelectorAll('[data-drawer]')
            .forEach(function (otherDrawer) {
              if (otherDrawer !== drawer) {
                closeProductDrawer(otherDrawer);
              }
            });

          drawer.classList.add('open', 'active', 'is-open');
          drawer.setAttribute('aria-hidden', 'false');

          document.body.classList.add(
            'product-drawer-open',
            'details-drawer-open'
          );

          lockScroll();
        });
      });

    document
      .querySelectorAll('[data-drawer-close]')
      .forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();

          var drawer = button.closest('[data-drawer]');

          closeProductDrawer(drawer);
          checkProductDrawerState();
        });
      });

    document
      .querySelectorAll('[data-drawer]')
      .forEach(function (drawer) {
        drawer.addEventListener('click', function (event) {
          if (event.target !== drawer) return;

          closeProductDrawer(drawer);
          checkProductDrawerState();
        });
      });

    /* ==========================================================
       CART DRAWER
       ========================================================== */

    var cartDrawer = document.getElementById('cart-drawer');

    function openCart() {
      if (!cartDrawer) return;

      closeMobileMenu();
      closeAllProductDrawers();

      cartDrawer.classList.add('open', 'active', 'is-open');
      cartDrawer.setAttribute('aria-hidden', 'false');

      document.body.classList.add('cart-drawer-open');

      lockScroll();
    }

    function closeCart() {
      if (!cartDrawer) return;

      cartDrawer.classList.remove('open', 'active', 'is-open');
      cartDrawer.setAttribute('aria-hidden', 'true');

      document.body.classList.remove('cart-drawer-open');

      unlockScrollIfNothingOpen();
    }

    document
      .querySelectorAll('[data-cart-toggle]')
      .forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          openCart();
        });
      });

    document
      .querySelectorAll('[data-cart-close]')
      .forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          closeCart();
        });
      });

    /* ==========================================================
       PRODUCT GALLERY
       ========================================================== */

    var mainImage = document.getElementById('product-main-img');

    var thumbnails = document.querySelectorAll(
      '[data-gallery-thumb]'
    );

    thumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function (event) {
        event.preventDefault();

        var imageSource =
          thumbnail.getAttribute('data-img-src');

        if (mainImage && imageSource) {
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = imageSource;
        }

        thumbnails.forEach(function (otherThumbnail) {
          otherThumbnail.classList.remove('active');
        });

        thumbnail.classList.add('active');
      });
    });

    /* ==========================================================
       EMAIL POPUP
       ========================================================== */

    var popup = document.getElementById('email-popup');

    var popupCloseButtons = document.querySelectorAll(
      '[data-popup-close]'
    );

    var popupForm = document.getElementById('popup-form');

    var popupCookieName = 'saunii_popup_dismissed';
    var popupShown = false;

    function popupDismissedRecently() {
      return (
        document.cookie.indexOf(
          popupCookieName + '=1'
        ) !== -1
      );
    }

    function showPopup() {
      if (!popup) return;
      if (popupShown) return;
      if (popupDismissedRecently()) return;

      popup.classList.add('active');
      document.body.classList.add('popup-open');

      popupShown = true;

      lockScroll();
    }

    function dismissPopup() {
      if (!popup) return;

      popup.classList.remove('active');
      document.body.classList.remove('popup-open');

      var dismissDays =
        getNumber(popup.getAttribute('data-popup-days'), 7);

      var dismissSeconds =
        dismissDays * 24 * 60 * 60;

      document.cookie =
        popupCookieName +
        '=1;path=/;max-age=' +
        dismissSeconds +
        ';SameSite=Lax';

      unlockScrollIfNothingOpen();
    }

    if (popup) {
      var delaySeconds = getNumber(
        popup.getAttribute('data-popup-delay'),
        10
      );

      var delayMilliseconds = delaySeconds * 1000;

      var useExitIntent =
        popup.getAttribute('data-popup-exit-intent') ===
        'true';

      window.setTimeout(showPopup, delayMilliseconds);

      if (useExitIntent) {
        document.addEventListener(
          'mouseout',
          function (event) {
            var leavingWindow =
              !event.relatedTarget &&
              !event.toElement &&
              event.clientY < 10;

            if (leavingWindow) {
              showPopup();
            }
          }
        );
      }

      popupCloseButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          dismissPopup();
        });
      });

      if (popupForm) {
        popupForm.addEventListener(
          'submit',
          function (event) {
            event.preventDefault();

            var emailField = popupForm.querySelector(
              'input[name="email"]'
            );

            var email = emailField
              ? emailField.value.trim()
              : '';

            if (!email) return;

            try {
              var requestBody = new URLSearchParams();

              requestBody.append('form_type', 'customer');
              requestBody.append('utf8', '✓');
              requestBody.append(
                'contact[email]',
                email
              );
              requestBody.append(
                'contact[accepts_marketing]',
                'true'
              );
              requestBody.append(
                'contact[tags]',
                'popup,newsletter'
              );

              fetch('/contact#contact_form', {
                method: 'POST',
                headers: {
                  'Content-Type':
                    'application/x-www-form-urlencoded',
                  Accept: 'application/json'
                },
                body: requestBody.toString()
              }).catch(function (error) {
                console.warn(
                  '[Saunii] Popup submission failed:',
                  error
                );
              });
            } catch (error) {
              console.warn(
                '[Saunii] Popup submission error:',
                error
              );
            }

            popupForm.style.display = 'none';

            var successMessage =
              document.getElementById('popup-success');

            if (successMessage) {
              successMessage.style.display = 'block';
            }

            window.setTimeout(dismissPopup, 2500);
          }
        );
      }
    }

    /* ==========================================================
       ESCAPE KEY CLOSES OPEN MENUS AND DRAWERS
       ========================================================== */

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      closeMobileMenu();
      closeCart();
      closeAllProductDrawers();

      if (popup && popup.classList.contains('active')) {
        popup.classList.remove('active');
        document.body.classList.remove('popup-open');
      }

      unlockScrollIfNothingOpen();
    });
  });
})();